import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import CommonTab from "../tabs";
import FortressCompanies from "./FortressCompanies";
import BankCodesTable from "./BankCodesTable";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 90px",
    marginLeft: "220px",
    boxSizing: "border-box",
  },
  title: {
    color: theme.colors.Violet,
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    fontSize: "24px",
    marginBottom: "6px",
  },
  description: {
    color: theme.colors.DodgerBlue,
    fontFamily: theme.fontFamily.MARKPROBOOK,
    fontSize: "14px",
    marginBottom: "20px",
  },
  tabBar: { marginBottom: "26px" },
}));

function FortressGatewayPage() {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState("companies");

  return (
    <div className={classes.root}>
      <div className={classes.title}>Payment Gateway</div>
      <div className={classes.description}>
        Choose which companies settle through Fortress (all others use Paystack),
        and maintain Fortress bank-code resolutions.
      </div>

      <div className={classes.tabBar}>
        <CommonTab
          choices={[
            { value: "companies", label: "Fortress Companies" },
            { value: "bankcodes", label: "Bank Code Resolutions" },
          ]}
          onColClick={(data) => setActiveTab(data.value)}
        />
      </div>

      {activeTab === "companies" ? <FortressCompanies /> : <BankCodesTable />}
    </div>
  );
}

export default FortressGatewayPage;
